import { useEffect, useState } from "react";

/**
 * Track a CSS media query from React.
 *
 * Needed where a layout decision cannot be expressed in classes alone: the
 * workspace divider sets an inline flex-basis on the two panes, and an inline
 * style has no breakpoint. Below the breakpoint the panes become tabs instead
 * and the style must not be applied at all (PRD FR-6.7).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [query]);

  return matches;
}
